exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error {\n  color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/auth/forgot/forgot.component.scss
// module id = ../../../../../src/app/auth/forgot/forgot.component.scss
// module chunks = main